<template>
    <div class="navbar">
      <img src="../../img/start_m.png" alt="" class="start" @click="routerTo('/mpage/m_notice')">
      <div class="tab">
        <img src="../../img/m_home.png" alt="" @click="routerTo('/mpage/m_notice')">
        <img src="../../img/m_video_rule.png" alt="" @click="routerTo('/mpage/m_vlog_rule')">
        <img src="../../img/m_pic_rule.png" alt="" @click="routerTo('/mpage/m_pic_rule')">
      </div>
    </div>
</template>

<script>
export default {
    name: 'navbar',
    data: function () {
        return {
            
        }
    },
    methods: {
      routerTo(path) {
        this.$router.push(path)
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navbar {
  position: fixed;
  bottom: 0;
  .start {
    width: 100%;
  }
  .tab {
    position: absolute;
    display: flex;
    bottom: 0.3rem;
    align-items: center;
    justify-content:space-between;
    img {
      width: calc(33% - 0.1rem);
    }
  }
}
</style>
